import { Component, computed, inject, Signal, output, viewChild } from '@angular/core';
import { SignupV2Service } from '../../signup-v2.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AutocompleteInputComponent } from '../../../signup/autocomplete-input/autocomplete-input.component';
import { AccountService } from '../../../../shared/account.service';
import { AddressService } from '../../../../shared/address.service';
import { DeliveryOptionsResponseItem } from '../../../../shared/types/account.types';
import { OnlyNumberDirective } from '../../../../shared/directives/only-number.directive';

@Component({
  selector: 'app-delivery-address-step',
  imports: [CommonModule, ReactiveFormsModule, AutocompleteInputComponent, OnlyNumberDirective],
  templateUrl: './delivery-address-step.component.html',
  styleUrl: './delivery-address-step.component.scss'
})
export class DeliveryAddressStepComponent {

  emailControl = viewChild<HTMLInputElement>('emailControl');

  svc = inject(SignupV2Service);
  accountService = inject(AccountService);
  addressService = inject(AddressService);

  // Output para comunicarse con el componente padre
  stepCompleted = output<void>();

  deliveryAddress = computed(() => this.svc.getDeliveryAddress());
  states = computed(() => this.svc.getStates());

  deliveryCoverageMessage: Signal<string | undefined> = computed(() => this.svc.getDeliveryCoverageMessage());

  deliveryOptions: DeliveryOptionsResponseItem[] = [];

  addressLoadedFromStorage: Signal<boolean> = computed(() => this.svc.getAddressLoadedFromStorage());

  invalid(name: string) { const c = this.svc.addressForm.get(name); return !!c && c.invalid && (c.dirty || c.touched); }

  valid(name: string) { const c = this.svc.addressForm.get(name); return !!c && c.valid && (c.dirty || c.touched); }

  private firstLoad = true;

  onValidSelectedAddress(address: any) {

    if (this.firstLoad) {
      this.firstLoad = false;
      return;
    }

    if (this.addressLoadedFromStorage()) {
      this.svc.setAddressLoadedFromStorage(false);
      return;
    }

    this.svc.setDeliveryAddress(address);

    if (!address) {
      this.svc.clearAddressInfo();
      return;
    }

    this.svc.fetchDeliveryOptions();

    this.svc.setAddressInfo(address);

    this.svc.addressForm.controls.email.markAsTouched();
    this.svc.addressForm.controls.email.markAsDirty();
    this.onEmailBlur(this.emailControl()!);
  }

  onEmailBlur(emailControl: HTMLInputElement) {
    this.svc.validateEmail(emailControl);
  }

  async onNext() {
    if (!this.svc.canProceed('delivery')) return;
    const isCompleted = await this.svc.markCompleted('delivery');
    if (isCompleted) {
      this.stepCompleted.emit();
    }
  }
}
